import { useQuery } from '@tanstack/react-query';
import {
  fetchNotificationPreferences,
  type NotificationPreferencesDto,
} from '@api/notifications';
import { notificationKeys } from './notificationQueryKeys';

export function useNotificationPreferences() {
  return useQuery<NotificationPreferencesDto>({
    queryKey: notificationKeys.preferences(),
    queryFn: fetchNotificationPreferences,
    staleTime: 5 * 60_000,
  });
}
